export enum IndexEuroCountriesEnum {
    Germany = 'Germany',
    France = 'France',
    Poland = 'Poland',
}

export enum ScenarioEnum {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
}

export enum CustomIndexEditorEnum {
    add = 'add',
    edit = 'edit',
    view = 'view'
}

export enum IIndexChartTypeEnum {
    Revenue = 'revenue',
    Cycles = 'cycles',
    EnergyBuy = 'energyBuy',
    EnergySell = 'energySell',
    MeanParticipation = 'meanParticipation',
}

export enum IndexTypeEnum {
    Operational = 'operationalIndex',
    Optimisation = 'optimisationIndex',
    SkipRates = 'skipRates',
}

export enum SkipRatesActionTypeEnum {
    Bid = 'Bid',
    Offer = 'Offer',
    Combined = 'Combined',
}

export enum SkipRatesStageEnum {
    Zero = 'Zero',
    One = 'One',
    Two = 'Two',
    Three = 'Three',
    Four = 'Four',
    Five = 'Five',
}

export enum SkipRatesSourceEnum {
    AllBm = 'All BM',
    Psa = 'Psa',
}

export enum IIndexUnitEnum {
    Pound = 'Pound',
    PoundPerMw = 'PoundPerMw',
    PoundPerMwh = 'PoundPerMwh',
    PoundPerKwPerYear = 'PoundPerKwPerYear',
    PoundPerThroughput = 'PoundPerThroughput',
}

export enum IIndexCurrencyEnum {
    Default = 'default',
    GBP = 'GBP',
    EUR = 'EUR',
}

export enum IIndexGranularityEnum {
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Year = 'Year',
}
